export enum CheckoutReturnType {
  startProcess,
  customerExists,
  convertGuestToCustomerAndSession,
  getCustomerContact,
  createCustomerContactAndCartPaymentMethodTo3Pay,
  createCustomerContacts,
  createCartContactsAndGetCartBalance,
  createPartialOrder,
  createBillingProfile,
  createBillOrder,
  updateProcessingOrderMaxPage,
  completed,
  tagCustomerById,
  getPaymentProfile,
  createCrossSellOrder,
  createBillOrder_crossSell,
  tagOrderById,
  updateQuestionnaireForTMS,
  completed_crossSell
}
